import {Api} from '@/api/Api';
import {deserialize} from './Deserializer';
import type {OPRFile} from "@/models/OPRFile";
import {OPRFileSchema} from "@/models/OPRFile";

export default class BidPackageCompanyFileAPI extends Api {

  index(projectId: number, bidPackageId: number, params: any): Promise<OPRFile[]> {
    return this.get({
      url: `projects/${projectId}/bid-packages/${bidPackageId}/files`,
      queryParams: params,
    })
    .then((res) => this.processResponse(res))
    .then(res => deserialize<OPRFile>(res, OPRFileSchema) as OPRFile[]);
  }

  store(projectId: number, bidPackageId: number, data: any): Promise<any> {
    const formData = new FormData(); // pass data as a form

    let key: string;
    let value: any;
    for ([key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return this.uploadFile({
      url: `projects/${projectId}/bid-packages/${bidPackageId}/files`,
      headers: {
      },
      body: formData,
    })
    .then((res) => this.processResponse(res))
    .then(res => res);
  }

  download(projectId: number, bidPackageId: number, file: OPRFile): Promise<void> {
    if (!file.file_path) {
      return Promise.reject('File URL is unavailable');
    }

    const loggingRequest = this.post({
      url: `projects/${projectId}/bid-packages/${bidPackageId}/files/${file.id}/download-activity`,
    })
      .then((response) => this.processResponse(response))
      .then(() => undefined);

    const link = document.createElement('a');
    link.href = file.file_path;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.append(link);
    link.click();
    link.remove();

    return loggingRequest;
  }

};
